const STORAGE_PREFIX = 'odysseyai.ai-sharing.v2:';
const pageChoices = new Map();

export const aiPermissionScope = (user) => user?.uid ? `account:${user.uid}` : 'guest';

// Remember explicit permission on this device, separately for each account and
// guest. A new disclosure version must use a new prefix. Never infer permission
// from sign-in, a prefilled prompt, a previous trip, or a privacy-policy link.
export const hasAiPermission = (scope) => {
  if (pageChoices.has(scope)) return pageChoices.get(scope);
  try {
    return localStorage.getItem(`${STORAGE_PREFIX}${scope}`) === 'allowed';
  } catch {
    return false;
  }
};

export const allowAiSharing = (scope) => {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${scope}`, 'allowed');
    pageChoices.delete(scope);
  } catch {
    // Explicit permission still works for this page when storage is blocked.
    pageChoices.set(scope, true);
  }
};

export const revokeAiSharing = (scope = 'guest') => {
  try {
    localStorage.removeItem(`${STORAGE_PREFIX}${scope}`);
    pageChoices.delete(scope);
  } catch {
    // Revocation wins over a stale receipt when storage is unavailable.
    pageChoices.set(scope, false);
  }
};
